import React, { useRef } from "react"
import { Input, Col } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import toast from "react-hot-toast"
import UploadFile from "../../../../assets/images/icons/upload-file.svg"
import closeIcon from "../../../../assets/images/icons/close.svg"

const PANImageUpload = ({
  file,
  setFile,
  extensionAllowedInput = ".jpg,.jpeg,.png",
  extensionAllowed = ["image/jpeg", "image/png"],
  placeholder = "Upload Document",
}) => {
  const fileRef = useRef(null)

  const onUploadFile = async (file) => {
    if (!file) {
      toast.error("Please select file.", {
        id: "toasterMessage",
      })
      return
    }
    if (!extensionAllowed.includes(file.type)) {
      toast.error("Please upload files in JPG, OR PNG format only.", {
        id: "toasterMessage",
      })
      return
    }

    const maxSize = 10 * 1024 * 1024
    if (file.size > maxSize) {
      toast.error("You can upload a maximum 10MB image", {
        id: "toasterMessage",
      })
      return
    }

    setFile(file)
  }

  const clearFile = () => {
    setFile(null)
  }

  return (
    <React.Fragment>
      <div
        className={`upload-file-input`}
        onClick={() => fileRef?.current?.click()}
      >
        <Input
          type="file"
          innerRef={fileRef}
          className="form-control d-none"
          placeholder={placeholder}
          accept={extensionAllowedInput}
          onChange={(e) => {
            const file = e.target.files[0]
            if (file) {
              onUploadFile(file)
            }
          }}
        />

        <Input
          type="text"
          className="form-control"
          id="horizontal-firstname-Input"
          value={file ? file.name : placeholder}
          readOnly
        />
        <img src={UploadFile} alt="" />
      </div>
      <span className="floating-labels">
        File format: jpeg, png | File size: Upto 10mb
      </span>

      {file && (
        <Col xl={12}>
          <div className="upload-file-signature mt-3 position-relative">
            <img
              style={{
                position: "absolute",
                right: "10px",
                top: "10px",
                width: "16px",
                height: "auto",
                cursor: "pointer",
              }}
              src={closeIcon}
              alt=""
              onClick={clearFile}
            />
            <img
              style={{
                width: "auto",
                maxHeight: "200px",
              }}
              src={URL.createObjectURL(file)}
              alt=""
            />
          </div>
        </Col>
      )}
    </React.Fragment>
  )
}

export default PANImageUpload
